// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wrdnj","question":"styles_question__2BwFr","description":"styles_description__18PqR"};